import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";

import mainTheme from "./mainTheme";
import styles from "../styles/Label.module.css"

const TabPanel = ({children, value, index, ...other}) => {
    return (<ThemeProvider theme={mainTheme}>
        <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </div>
    </ThemeProvider>)
}

export default TabPanel;